import { ReactNode } from 'react';
import strivreLogo from '../../assets/images/strivre-logo.svg';

export default function AuthPageShell({
  title,
  children,
}: {
  title: string;
  children: ReactNode;
}) {
  return (
    <div className="min-h-screen w-full bg-strivre-softgrey px-4 py-10">
      <div className="mx-auto max-w-md">
        <div className="animate-fade-in rounded-2xl border border-strivre-lightnavy bg-white p-8 shadow-sm">
          <div className="mb-8 text-center">
            <img src={strivreLogo} alt="Strivre Logo" className="mx-auto h-12 w-auto" />

            <h1 className="mt-5 text-2xl font-bold text-strivre-navy">
              {title}
            </h1>
          </div>

          {children}
        </div>
      </div>
    </div>
  );
}